'use client';

import React from 'react';
import { TileFragmentFragment } from '@/integrations/crystallize/__gql-codegen-types/catalogue/graphql';
import TilesArrayRenderer from '@/ui/components/tileRenderers/PageGridRenderer/tiles-array-renderer';

interface ContentTilesProps {
  tiles: TileFragmentFragment[];
  className?: string;
}

/**
 * Renders an array of CMS tiles through the shared TilesArrayRenderer, so tiles look identical to
 * how they render elsewhere. Renders nothing when no tiles are configured. The optional `className`
 * is applied to the wrapping element, letting each caller supply its own layout (e.g. a full-bleed
 * breakout) without this component knowing about any specific page's spacing.
 */
export function ContentTiles({ tiles, className }: Readonly<ContentTilesProps>) {
  if (!tiles || tiles.length === 0) {
    return null;
  }

  return (
    <div className={className}>
      <TilesArrayRenderer tiles={tiles} />
    </div>
  );
}
